import { registerModuleCatalog } from '@/shared/i18n/i18n';

// Porta leve do módulo para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca e o
// catálogo de textos. A tela sai pela `public.ts`, carregada sob demanda pela rota.

// `eager`: os títulos do manifesto aparecem no ⌘K e no breadcrumb antes de a tela abrir.
registerModuleCatalog('fund', (locale) => import(`./locales/${locale}.po`), { eager: true });

export { FUND_LIST_PATH, fundDetailScreen, fundListScreen, fundPath } from './fund.screen';
export { FUND_TABS, fundDetailSearch, fundListSearch, type FundDetailSearch, type FundListSearch, type FundTab } from './fund.search';

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadFundGuides = () => import('./fund.guide');
